import { call } from "./utils";

export const getPatientDisponibility = async (data) =>
  await call({ url: "/get/patient/disponibility", data: { data } });

export const updatePatientDisponibility = async (data) =>
  await call({ url: "/update/patient/disponibility", data: { data } });

export const getDateTimeActivityPatient = async (data) =>
  await call({
    url: "/get/patient/disponibility/activityPatients",
    data: { data },
  });
